import UserInfoGroup from '../../shared/userInfoGroup/UserInfoGroup';
import { ArrowDownIcon2 } from '../../shared/icons/icons';
import { Dropdown } from 'react-bootstrap';
import ProfilePictureUpload from '../../profile/ProfilePictureUpload';
import { User } from '../../../store/types';

interface IProfileWidgetProps {
    currentUser: User;
}

const ProfileWidget = ({ currentUser }: IProfileWidgetProps) => {
    return (
        <div className='susy-profile-widget d-flex align-items-center'>
            <UserInfoGroup user={currentUser} />
            <Dropdown>
                <Dropdown.Toggle
                    className='susy-button susy-button-ghost susy-button-md'
                    type='button'
                    aria-haspopup='true'
                    aria-expanded='false'
                >
                    <ArrowDownIcon2 />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    <Dropdown.Item>
                        <ProfilePictureUpload />
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};

export default ProfileWidget;
